import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { setupExternalSvgHydrator } from './app/core/utils/external-svg-hydrator';

bootstrapApplication(App, appConfig)
  .then(() => {
    setupExternalSvgHydrator();
  })
  .catch((err) => console.error(err));
